import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { SelectExtended } from 'src/components';
import { useOneFormContext } from 'src/feature-app/OneForm';
import { useSelector } from 'react-redux';
import { OneFormState } from 'src/types';
import { styled } from '@volkswagen-onehub/components-core';

const InputsWrapper = styled.div`
  padding-top: 44px;
  width: 100%;
  @media all and (min-width: 560px) {
    width: 303px;
  }
  @media all and (min-width: 960px) {
    width: 320px;
  }
`;

const motivoOptions = [
  { code: null, key: null, name: null },
  {
    code: 'VE',
    key: 'VE',
    name: 'Venta',
  },
  {
    code: 'ONESHOP',
    key: 'ONESHOP',
    name: 'T-Cross Clic2Go',
  },
  {
    code: 'PV',
    key: 'PV',
    name: 'Posventa',
  },
  {
    code: 'GDP',
    key: 'GDP',
    name: 'Gestión de datos personales y privacidad',
  },
  {
    code: 'OT',
    key: 'OT',
    name: 'Otras consultas',
  },
];

export const PantallaMotivoSAC = () => {
  const { register, watch } = useFormContext();
  const [requestType, setRequestType] = useState('');
  const { fields } = useSelector((state: OneFormState) => state.formData);

  useEffect(() => {
    if (fields.requestType) {
      setRequestType(fields.requestType);
    }
  }, []);

  function handleChangeMotivo(event: any) {
    const newMotivo = event.currentTarget.value;
    setRequestType(newMotivo);
  }

  return (
    <>
      <InputsWrapper>
        <SelectExtended
          options={motivoOptions}
          name="requestType"
          label="Elige un motivo"
          isRequired
          updateFields
          value={requestType}
          onClick={() => {}}
          setOption={setRequestType}
          handleChange={handleChangeMotivo}
          innerRef={register('requestTypeInput', {
            validate: () => {
              if (!requestType) {
                return false;
              }
              return true;
            },
          })}
        />
      </InputsWrapper>
    </>
  );
};
